import { Dialog, DialogContent, DialogTitle } from '@localagent/ui';

export interface ImageLightboxProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  src: string;
  label: string;
  title?: string;
  testId: string;
}

export function ImageLightbox({ open, onOpenChange, src, label, title, testId }: ImageLightboxProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        data-testid={testId}
        aria-describedby={undefined}
        className="w-auto max-w-[92vw] gap-3 border-0 bg-card p-3"
      >
        <DialogTitle className="pr-8 text-label">{title ?? label}</DialogTitle>
        <div className="rounded-md bg-sunken p-2">
          <img
            data-testid={`${testId}-image`}
            src={src}
            alt={label}
            className="block max-h-[82vh] max-w-[88vw] rounded object-contain"
            style={{ filter: 'none' }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}
